const forms = [
  {
    name: "Purchases",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Supplier",
        type: "selectandadd",
        path: "/app/supplier/add",
        form: {
          name: "supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Supplier",
          api: "get-all-suppliers-contractors",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Purchase order number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Purchase order date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Due Date",
        type: "date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Purchase order due date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
